const icon = require('vue-svgicon');
icon.register({
    'briefcase': {
        width: 20,
        height: 20,
        viewBox: '0 0 20 20',
        data: `<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M16.666 18.334H3.333a2.222 2.222 0 01-2.223-2.222V6.111c0-1.226.995-2.222 2.223-2.222h3.333V2.222c0-.307.249-.555.556-.555h5.555c.307 0 .556.248.556.555V3.89h3.333c1.227 0 2.222.996 2.222 2.222V16.112a2.221 2.221 0 01-2.222 2.222zM12.222 2.778H7.777v1.11h4.445v-1.11zM16.666 5c.614 0 1.112.498 1.112 1.112v3.333H2.22V6.112C2.221 5.498 2.72 5 3.333 5h13.333zm-8.889 5.557v2.222h4.445v-2.222H7.777zm5.556 0h4.444v5.555c0 .614-.497 1.111-1.11 1.111H3.332a1.111 1.111 0 01-1.111-1.11v-5.556h4.444v3.333h6.667v-3.333z" _fill="#000"/>`,
    },
});
